var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconamoonSearchLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:search-light",
    clipPath: "url(#clip0_4046_13301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6001 14.5986L11.4152 11.4137M11.4152 11.4137C11.96 10.8689 12.3921 10.2222 12.687 9.51039C12.9818 8.79859 13.1335 8.0357 13.1335 7.26526C13.1335 6.49481 12.9818 5.73192 12.687 5.02012C12.3921 4.30833 11.96 3.66157 11.4152 3.11679C10.8704 2.572 10.2236 2.13986 9.51185 1.84502C8.80006 1.55019 8.03716 1.39844 7.26672 1.39844C6.49628 1.39844 5.73338 1.55019 5.02159 1.84502C4.30979 2.13986 3.66304 2.572 3.11825 3.11679C2.01801 4.21703 1.3999 5.70928 1.3999 7.26526C1.3999 8.82123 2.01801 10.3135 3.11825 11.4137C4.2185 12.514 5.71074 13.1321 7.26672 13.1321C8.8227 13.1321 10.3149 12.514 11.4152 11.4137Z",
    stroke: "#3B3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4046_13301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonSearchLight);
export default __webpack_public_path__ + "static/media/iconamoon_search-light.c5f30dadd32c8dad4b3aac5ee32b91e3.svg";
export { ForwardRef as ReactComponent };